'use client';

import { AccountType } from '@/autogenerated/@prisma/prisma-mongo-client';
import { identify } from '@/lib/analyticsClientSide';

export default function AnalyticsIdentifyRecorder({
  user,
}: {
  user: {
    id: string;
    email?: string | null;
    name?: string | null;
    accountType?: AccountType;
    idVerificationStatus: boolean;
  };
}) {
  identify(user);
  return null;
}
